import * as actionTypes from "./actionTypes";
import CustomersApiClient from "../../api/customersApiClient";
import { getSortingObject } from "../../util/utils";

export const getClientsList = (
  page,
  rowsPerPage,
  sortBy,
  searchText,
  integrationId
) => {
  const { sortField, sortOrder } = getSortingObject(sortBy);
  return (dispatch) => {
    dispatch({ type: actionTypes.GET_CUSTOMERS_LOADING, value: true });
    CustomersApiClient.fetchClientsList(
      page,
      rowsPerPage,
      sortField,
      sortOrder,
      searchText,
      integrationId
    )
      .then((res) => {
        dispatch({
          type: actionTypes.GET_CUSTOMERS_DATA_AND_LOADING,
          data: res.data,
          page: page,
          rowsPerPage: rowsPerPage,
        });
      })
      .catch((e) => {
        console.error(e.response.data);
      })
      .finally(() => {
        dispatch({ type: actionTypes.GET_CUSTOMERS_LOADING, value: false });
      });
  };
};

export const setSelectedCompany = (newCompany) => {
  return (dispatch) =>
    dispatch({
      type: actionTypes.SET_SELECTED_COMPANY,
      payload: newCompany,
    });
};

export const getNngWsCustomer = (integrationId) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.SET_NNG_WS_CUSTOMER_ID,
      value: true,
      key: "loading",
    });
    CustomersApiClient.getNngWsCustomer(integrationId)
      .then((res) => {
        dispatch({
          type: actionTypes.SET_NNG_WS_CUSTOMER_ID,
          value: res.data.result.nngWsCustomerId,
          key: "value",
        });
      })
      .catch((e) => {
        dispatch({
          type: actionTypes.SET_NNG_WS_CUSTOMER_ID,
          value: null,
          key: "value",
        });
        console.error(e.response.data);
      })
      .finally(() => {
        dispatch({
          type: actionTypes.SET_NNG_WS_CUSTOMER_ID,
          value: false,
          key: "loading",
        });
      });
  };
};

export const getCompanyName = (integrationId) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.GET_COMPANY_NAME_LOADING, value: true });
    CustomersApiClient.fetchCompanyName(integrationId)
      .then((res) => {
        dispatch({
          type: actionTypes.GET_COMPANY_NAME,
          payload: res.data
      });
      })
      .catch((e) => {
        console.error(e.response.data);
      })
      .finally(() => {
        dispatch({ type: actionTypes.GET_COMPANY_NAME_LOADING, value: false });
      });
  };
};

export const refreshCache = (customerId, integrationId, refreshType) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.REFRESH_CACHE, value: true, key: 'refreshCacheLoading' });
    CustomersApiClient.refreshCache(customerId, integrationId, refreshType)
      .then((res) => {
        dispatch({
          type: actionTypes.REFRESH_CACHE,
          value: res.data.result,
          key: 'lastUpdated'
        })
      })
      .catch((e) => {
        console.error(e.response.data);
      })
      .finally(() => {
        dispatch({ type: actionTypes.REFRESH_CACHE, value: false, key: 'refreshCacheLoading' });
      });
  };
};
